export const WarningTriangleOutlineIcon = ({ color = "#FF6B6B", className = "" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 2L14.5 13.5H1.5L8 2Z"
      fill="none"
      stroke={color}
      strokeWidth="1.3"
      strokeLinejoin="round"
    />
    <path
      d="M8 6.3V9.5"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <circle cx="8" cy="11.4" r="0.85" fill={color} />
  </svg>
);
